var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBuilding(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#building_svg__filter0_d_1850_5280)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30.5,
    r: 30,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.667 17.166c.736 0 1.333.598 1.333 1.334v24a1.333 1.333 0 11-2.667 0V19.833h-8V42.5a1.333 1.333 0 11-2.666 0V31.833h-8V42.5a1.333 1.333 0 01-2.667 0v-12c0-.736.597-1.334 1.333-1.334h9.334V18.5c0-.736.597-1.334 1.333-1.334h10.667zM40 22.5c.736 0 1.333.597 1.333 1.333v1.334c0 .736-.597 1.333-1.333 1.333h-1.333a1.333 1.333 0 01-1.334-1.334v-1.333c0-.736.597-1.333 1.334-1.333H40zm1.333 8c0-.736-.597-1.334-1.333-1.334h-1.333c-.737 0-1.334.598-1.334 1.334v1.333c0 .736.597 1.334 1.334 1.334H40c.736 0 1.333-.598 1.333-1.334V30.5zM40 35.833c.736 0 1.333.597 1.333 1.334V38.5c0 .736-.597 1.333-1.333 1.333h-1.333a1.333 1.333 0 01-1.334-1.333v-1.334c0-.736.597-1.333 1.334-1.333H40zM29.333 34.5c.737 0 1.334.597 1.334 1.333v1.334c0 .736-.597 1.333-1.334 1.333H28a1.333 1.333 0 01-1.333-1.334v-1.333c0-.736.597-1.333 1.333-1.333h1.333z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "building_svg__filter0_d_1850_5280",
    x: 0,
    y: 0.5,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1850_5280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1850_5280",
    result: "shape"
  })))));
}
export default SvgBuilding;